import {shallowEqual, useSelector} from 'react-redux';

type TAnySelector = (state: any) => any;

// TODO удалить и использовать useExactSelector, в который передавать selector. Например useExactSelector(model.selectors.item)
const useTypedSelector = <Selector extends TAnySelector = TAnySelector>(
  selector: Selector,
): ReturnType<Selector> => useSelector(selector, shallowEqual);

export default useTypedSelector;
